import { render, staticRenderFns } from "./examine.vue?vue&type=template&id=4fd1d922"
import script from "./examine.vue?vue&type=script&lang=js"
export * from "./examine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports